/* eslint-disable react/require-default-props */
/* eslint-disable react/no-array-index-key */

import React from 'react';
import { connect } from 'react-redux';

import { useTranslation } from 'providers/GILT.provider';
import { selectCurrentSalonCurrency } from 'selectors/currentSalon.selectors';

import ReportTableContainer from 'reports/Common/ReportTable';
import { convertStylistCategoryToCategoryRevenueTableData } from 'reports/utils';

const CategoryRevenueTable = ({ startDate, endDate, dataCategory, dataProducts, stylists, currency }) => {
  const { t } = useTranslation();
  return (
    <div id="revenue-category">
      <ReportTableContainer
        startDate={startDate}
        endDate={endDate}
        title={t('businessReports.revenueReports.revenueByCategoryTitle')}
        data={{
          rows: convertStylistCategoryToCategoryRevenueTableData(
            dataCategory,
            dataProducts,
            stylists.filter((s) => s.total_revenue !== 0),
            currency,
            t,
          ),
        }}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  currency: selectCurrentSalonCurrency(state),
});

const CategoryRevenueTableHoc = connect(mapStateToProps)(CategoryRevenueTable);

export default CategoryRevenueTableHoc;
